import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import MCVector from './mc_open_vector.svg';

export function VectorBlock(props) {
  return (
    <div className={props.className}>
      <Image
        src={MCVector}
        alt='micro centrifuge vector'
        className={`${props.className}_image`}
      />
    </div>
  );
}

VectorBlock.propTypes = {
  /**
   * ClassName to set on Component
   */
  className: PropTypes.string,
};

VectorBlock.defaultProps = {};
